import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DocumentDownloadDto, DocumentsDto, MyArvatoEnvironment } from '@myarvato/shared/models';
import { UploadDocumentDto } from '@myarvato/modules/transport/models';

@Injectable({
  providedIn: 'root',
})
export class DocumentsService {
  private readonly environment = inject(MyArvatoEnvironment);
  private readonly httpClient = inject(HttpClient);

  private requestOptions = {
    headers: new HttpHeaders({
      'x-skip-all-interceptor-handling': 'true',
      'x-skip-loading-interceptor-handling': 'true',
      'x-error-message-target-key': 'none',
    }),
  };

  getData(id: string): Observable<DocumentsDto> {
    return this.httpClient.get<DocumentsDto>(this.environment.url.api + `Transport/Documents/${id}`, this.requestOptions);
  }

  uploadDocument(dto: UploadDocumentDto): Observable<boolean> {
    const formData = new FormData();
    formData.append('file', dto.file); // actual file
    formData.append('documentType', dto.documentType); // RALF document type, NOT mime type

    dto.handlingUnits.forEach((unit, index) => {
      formData.append(`handlingUnits[${index}].trackingNumber`, unit.trackingNumber);
      formData.append(`handlingUnits[${index}].transportId`, unit.transportId);
    });

    return this.httpClient.post<boolean>(this.environment.url.api + `Transport/Documents/Upload`, formData, this.requestOptions);
  }

  /**
   * Retrieves the decrypted download URL for the given encrypted download URL.
   * @param encryptedDownloadUrl - The encrypted download URL.
   * @returns An Observable that emits the decrypted download URL as a string.
   */
  getDecryptedDownloadUrl(encryptedDownloadUrl: string): Observable<string> {
    const payload: DocumentDownloadDto = {
      encryptedDownloadUrl: encryptedDownloadUrl,
    };

    return this.httpClient.post<string>(this.environment.url.api + 'Transport/Documents/Download', payload);
  }

  getDocumentTypes(): Observable<string[]> {
    return this.httpClient.get<string[]>(this.environment.url.api + 'Transport/Documents/Types');
  }
}
